import { createAction, props } from '@ngrx/store';

export const initiateOAuth = createAction('[Auth] Initiate OAuth');
export const authSuccess = createAction(
  '[Auth] OAuth Success',
  props<{ idToken: string; refreshToken: string; userId: string, customToken: string }>(),
);
export const authFailure = createAction(
  '[Auth] OAuth Failure',
  props<{ error: any }>(),
);


export const logout = createAction('[Auth] Logout');